/**
 * @override @amblique/contentful base-image fragment
 *
 * Adds intrinsic `width`/`height` to each responsive asset so the renderer can
 * emit explicit `width`/`height` HTML attributes (CLS reduction) even when the
 * author leaves the entry-level display width/height blank. See
 * `app/contentful/models/image.jsx`.
 *
 * Kept in king-living (not regenerated) so `yarn contentful generate` won't
 * overwrite it. If the upstream autogenerated fragment changes, mirror it here.
 */

import gql from 'graphql-tag';

export const BaseImageFragment = gql`
  fragment BaseImageFragment on Image {
    __typename
    sys {
      id
    }
    alignment
    altText
    description
    imageDescriptionContent: descriptionContent {
      json
    }
    desktopAsset {
      url
      title
      description
      contentType
      width
      height
    }
    fit
    focus
    format
    height
    mobileAsset {
      url
      title
      description
      contentType
      width
      height
    }
    openInNewTab
    quality
    tabletAsset {
      url
      title
      description
      contentType
      width
      height
    }
    title
    url
    width
  }
`;
